__turbopack_context__.v({
  "chip": "lTqhda_chip",
  "icon": "lTqhda_icon",
  "iconButton": "lTqhda_iconButton",
});
